// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { TaskDateEditabilityFragmentDoc } from '../../../../fragments/circularFragments.generated';
export type ScheduleIntervalDetailsFragment = { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number };

export type ScheduleTaskDateEditabilityFragment = { __typename?: 'ScheduleTask', id: string, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number }, canEditDuration: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEditEndDate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEditStartDate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export const ScheduleIntervalDetailsFragmentDoc = gql`
    fragment ScheduleIntervalDetails on CalendarInterval {
  startDate
  endDate
  durationInDays
}
    `;
export const ScheduleTaskDateEditabilityFragmentDoc = gql`
    fragment ScheduleTaskDateEditability on ScheduleTask {
  ...TaskDateEditability
  interval {
    ...ScheduleIntervalDetails
  }
}
    ${TaskDateEditabilityFragmentDoc}
${ScheduleIntervalDetailsFragmentDoc}`;